export enum SprintState {
  Planned = 'planned',
  Active = 'active',
  Completed = 'completed',
  Canceled = 'canceled',
}
